// extracted by mini-css-extract-plugin
export default {"HistoryModalContainer":"rI_rJ"};